import React from 'react';
import { Link } from "@remix-run/react";
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { PlayImage } from '../../../components/Image/PlayImage';
import { PlayContainer, defaultContainerPadding } from '../../../components/PlayContainer/PlayContainer';
import { usePath } from '../../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowSectionMobile = ({
  show
}) => {
  const {
    videoShowPath
  } = usePath();
  return /*#__PURE__*/_jsx(PlayContainer, {
    sidePadding: {
      ...defaultContainerPadding,
      default: 0
    },
    children: /*#__PURE__*/_jsxs(StyledShowSection, {
      to: videoShowPath(show),
      children: [/*#__PURE__*/_jsx(PlayImage, {
        aspectRatio: '16/9',
        src: show.imageUrl,
        width: 320,
        alt: show.title
      }), /*#__PURE__*/_jsx(ShowName, {
        children: show.title
      })]
    })
  });
};
const StyledShowSection = styled(Link).withConfig({
  displayName: "ShowSectionMobile__StyledShowSection",
  componentId: "sc-ayh1ch-0"
})(["align-items:center;flex-shrink:0;display:flex;background-color:", ";padding:16px;> *:first-child{width:104px;flex-shrink:0;}", "{display:none;}"], Colors.BLACK, Viewports.for('largeUp'));
const ShowName = styled.span.withConfig({
  displayName: "ShowSectionMobile__ShowName",
  componentId: "sc-ayh1ch-1"
})(["color:", ";", ";margin-left:16px;"], Colors.WHITE, Fonts.medium(20));